
export class DocumentTestData {
  currentTest: any;
  testNumber: string;
  firstRevisionId: string;
  revisionId: string;
  revisionName: string;
  revisionStatus: string;
  workflowId: string;
  productionType?: string;
  interpretationText?: string;
  resourceId?: string;
}

export enum ResourceSearchType {
  BY_WORKFLOW_REQUEST = 'workflowRequest',
  BY_CONTEXT = 'context', // search by current revision == context, usually for resources that don't connect to diagnosticOrder but to current revision
  BY_ID = 'id'
}
